import React,{Component} from 'react';

import './Home.css';

import { 
    homeBanner, logo
} from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Footer from '../../components/Footer/Footer';
import routes from '../../_utils/routes';
const image = require('./image.png')

interface Props{
    history?:any,    
}

class Home extends Component<Props,{}>{
    render(){
        return (
        <Page 
            footer={<Footer/>}
            id="home"
            banner={{
                bannerImage:homeBanner,
                big:true,
                customTitle:
                    <div className="home-banner">
                        <img className="home-banner-image" src={logo}/>
                        <div className="home-banner-title">
                            <div className="home-banner-title-main">
                                Sentinel 3
                            </div>
                            <div className="home-banner-title-sub">
                                <i className="fas fa-satellite"/> Production Service
                            </div>
                        </div>
                    </div>
                ,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    <div className="title-3">Overview</div>
                    <p>
                        The Sentinel-3A (S3A) Production service is a central component of the Copernicus Space Component
                        (CSC) operations. Its primary role is to generate products from the Sentinel-3A satellite
                        measurements.
                        <br/>
                        <br/>
                        The aim of the S3A systematic production service is to process data acquired by the
                        Sentinel satellites and deliver the generated data on time (timeliness is defined in the SLA).
                    </p>
                    <br/>
                    <br/>
                    <div className="title-3">Production Service characteristics</div>
                    
                    <div className="text-with-icons-container">
                        <div className="text-with-icons">
                            <div className="text-with-icons-icon">
                                <i className="fas fa-microchip"/>
                            </div>
                            {/* <div className="text-with-icons-title">Team</div> */}
                            <div className="text-with-icons-text">
                                Technology obsolescence management
                            </div>
                        </div>
                        <div className="text-with-icons">
                            <div className="text-with-icons-icon">
                                <i className="fas fa-weight-hanging"/>
                            </div>
                            {/* <div className="text-with-icons-title">Outcome</div> */}
                            <div className="text-with-icons-text">
                                Robustness to failure and capacity to recover
                            </div>
                        </div>
                        <div className="text-with-icons">
                            <div className="text-with-icons-icon">
                                <i className="fas fa-cloud-download-alt"/>
                            </div>
                            
                            {/* <div className="text-with-icons-title">Goal</div> */}
                            <div className="text-with-icons-text">
                                Elasticity: the production system is scalable to face temporal large variations of computation
                                and storage resources needs
                            </div>
                        </div>
                        <div className="text-with-icons">
                            <div className="text-with-icons-icon">
                                <i className="fas fa-euro-sign"/>
                            </div>
                            {/* <div className="text-with-icons-title">Outcome</div> */}
                            <div className="text-with-icons-text">
                                Cost efficiency in terms of resources usage
                            </div>
                        </div>
                        <div className="text-with-icons">
                            <div className="text-with-icons-icon">
                                <i className="fas fa-sync-alt"/>
                            </div>
                            {/* <div className="text-with-icons-title">Outcome</div> */}
                            <div className="text-with-icons-text">
                                Interoperability with the other CSC ground segment components
                            </div>
                        </div>
                    </div>

                    <p>
                        <b>
                            This production service includes NRT, STC and NTC products generation from all S3A instruments
                            (plus SYNERGY).
                        </b>
                    </p>

                    <img className="image" src={image}/>

                    <p>
                        The products generated by the systematic production operations are made available on a Production
                        Interface Delivery Point (PRIP) and includes:
                    </p>
                    <ul>
                        <li>
                            User level data: the downloaded CADU stream is processed into L0, L1 and L2 products in line
                            with the mission specificities, including the generation of PDUs from the elementary L0, L1
                            and L2 initial products.
                        </li>
                        <li>
                            Engineering level data intended for instrument performance monitoring and calibration
                            activities.
                        </li>
                        <li>
                            Satellite housekeeping data, intended for spacecraft operations support.
                        </li>
                    </ul>
                    <br/>
                    <br/>

                </div>
            </div>
        </Page>
        );
    }

};


export default Home;
